// AuthFunctions.js
import React, { Component } from "react";
import Keycloak from "keycloak-js";
// import { authConfiguration } from "../components/custom/common";
// import { Loader, Login } from '../actions/LoginActions';
// import { connect } from "react-redux";
import API from "../../components/helpers/endpointservice";
import Actions from "../../action/api";
// import { logoutRedirect } from "../../action/api";
import { authConfiguration } from "../custom/common";
import { Loader, Login } from "../../action/LoginActions";
import { connect } from "react-redux";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

let isOpen = true;
class AuthFunctions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kc: null,
      isLoading: false,
      isLogin: localStorage.getItem("isLoginTAC") === "true" ? true : false,
    };
  }

  componentDidMount() {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const queryParams = new URLSearchParams(url.search);
    const email = queryParams.get("email");
    const realm = queryParams.get("realm");
    if (email && realm) {
      localStorage.setItem("userNameTAC", email);
      localStorage.setItem("realmNameTAC", realm);
    }
    this.fetchKeycloakConfig();
    this.Interval();
  }

  setupIdleTimer() {
    let idleTimer;
    const resetTimer = () => {
      clearTimeout(idleTimer);
      //   idleTimer = setTimeout(this.handleSession, 1800000);
      // idleTimer = setTimeout(this.handleSession, 1200000); // After 20 minutes it gets logout
    };

    const events = [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "load",
      "touchmove",
      "click",
      "scroll",
    ];
    events.forEach((event) => {
      document.addEventListener(event, resetTimer);
    });

    resetTimer();

    // Clear event listeners on component unmount
    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      clearTimeout(idleTimer);
    };
  }

  handleSession = () => {
    const session = JSON.parse(localStorage.getItem("isSessionExpiredTAC"));
    localStorage.setItem("isSessionExpiredTAC", "true");
    let idleTimer;
    const resetTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(this.handleSession, 1800000); // After 20 minutes it gets logout
    };

    const events = [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "load",
      "touchmove",
      "click",
      "scroll",
    ];
    events.forEach((event) => {
      document.removeEventListener(event, resetTimer);
    });
  };

  checkTokenReferesh = () => {
    if (this.state.kc) {
      // this.setupIdleTimer();
      this.state.kc.onTokenExpired = () => {
        console.log("Token expired. Refreshing...");
        this.refreshAccessToken();
      };
    }
  };

  getCurrentSubdomain = () => {
    const parts = window.location.hostname.split(".");
    console.log(parts[0]);
    return parts.length > 2 ? parts[0] : null;
  };

  fetchKeycloakConfig = async (userName) => {
    const currentENV = process.env.REACT_APP_ENV;
    console.log(currentENV);
    let userNames = localStorage.getItem("userNameTAC");
    let realmName = "";
    if (currentENV == "PROD") {
      realmName = this.getCurrentSubdomain() || "qantler";
      localStorage.setItem("realmNameTAC", realmName);
    } else {
      realmName = localStorage.getItem("realmNameTAC") || "";
    }

    // let realmName = this.getCurrentSubdomain() || 'qantler';
    // localStorage.setItem("realmNameTAC", realmName);
    let password = localStorage.getItem("passwordTAC");
    let accessToken = localStorage.getItem("AccessTokenTAC");
    let refreshToken = localStorage.getItem("RefreshTokenTAC");
    console.log(realmName, accessToken, refreshToken);
    const pathcheck = window.location.pathname.endsWith("/setpassword");

    if (realmName && !pathcheck) {
      try {
        const keycloakConfig = {
          url: authConfiguration.keycloackUrl,
          realm: realmName,
          clientId: authConfiguration.clientId,
        };

        const keycloakInstance = new Keycloak(keycloakConfig);
        this.setState({ kc: keycloakInstance }, () =>
          this.checkTokenReferesh()
        );
        if (isOpen) {
          let realm = this.getCurrentSubdomain() || "qantlersg";
          this.props.dispatch(Loader(true));
          localStorage.setItem("isLoginTAC", false);
          this.props.dispatch(Login(false));
          let load = localStorage.getItem("AccessTokenTAC")
            ? "check-sso"
            : "check-sso";
          // let RedirectURL = accessToken ? false : `http://localhost:3000/admin/key`;
          let RedirectURL = "";
          // let RedirectURL = accessToken ? false : `https://${realm}.${authConfiguration?.redirectUri}`;
          if (currentENV == "PROD") {
            RedirectURL = accessToken
              ? false
              : `https://${realm}.${authConfiguration?.redirectUri}`;
          } else {
            RedirectURL = accessToken ? false : authConfiguration?.redirectUri;
          }
          let initOption = {
            onLoad: load, // Supported values: 'check-sso' , 'login-required'
            pkceMethod: "S256",
            redirectUri: RedirectURL,
            checkLoginIframe: true,
          };
          await keycloakInstance.init({
            onLoad: load,
            checkLoginIframe: false,
            pkceMethod: "S256",
            redirectUri: RedirectURL,
          });

          if (!keycloakInstance.authenticated) {
            const loginOptions =
              currentENV === "PROD" ? {} : { loginHint: userNames };

            await keycloakInstance.login(loginOptions);
            // await keycloakInstance.login({
            //   loginHint: userNames,
            // });
            const keysToRemove = [
              "AccessTokenTAC",
              "UserInfoTAC",
              "isLoginTAC",
              "iscametoElseScopeTAC",
              "realmNameTAC",
              "redirectURLTAC",
              "userNameTAC",
              "idTokenTAC",
              "isSessionExpiredTAC",
              "isSSOConfigTAC",
            ];

            // const keysToRemove = [
            //     'AccessTokenDMS',
            //     'UserInfoDMS',
            //     'isLoginDMS',
            //     'iscametoElseScopeDMS',
            //     'realmNameDMS',
            //     'redirectURLDMS',
            //     'userNameDMS',
            //     'idTokenDMS',
            //     'isSessionExpiredDMS',
            //     'userDataDecodeDMS',
            //     'UserIdDMS',
            //     'RoleDMS',
            //     'decodedTokenDataDMS',
            //     'dmsRolesDMS',
            //     'currentRoleDMS',
            //     'isUserValidDMS'

            // ];

            keysToRemove.forEach((key) => localStorage.removeItem(key));
            // window.location.href = "/admin/login"
          } else {
            let idTokenParsed =
              keycloakInstance.idTokenParsed || jwtDecode(accessToken);
            console.log(keycloakInstance.idTokenParsed);
            console.log(jwtDecode(keycloakInstance?.token));
            let roleTokenParsed =
              jwtDecode(keycloakInstance?.token) || jwtDecode(accessToken);
            console.log(roleTokenParsed);
            const roles =
              roleTokenParsed?.resource_access?.tenant_admin_center_app_id
                ?.roles || [];

            const userRoles =
              roles.length > 0
                ? roles.includes("Admin")
                  ? "Admin"
                  : roles[0]
                : this.state.kc?.idTokenParsed?.user_role || "";
            let value = {
              name: idTokenParsed.name || "",
              expTime: idTokenParsed.exp || "",
              userRole: userRoles,
              userId: idTokenParsed.user_id || "",
            };
            console.log(value);
            // let value = {
            //   name: idTokenParsed.name || "",
            //   expTime: idTokenParsed.exp || "",
            //   userRole:
            //     roleTokenParsed?.resource_access?.tenant_admin_center_app_id
            //       .roles[0] ??
            //     (idTokenParsed.user_role || ""),
            //   userId: idTokenParsed.user_id || "",
            // };

            localStorage.setItem("userNameTAC", idTokenParsed?.email || "");

            isOpen = false;
            let localrole = JSON.stringify(value.userRole);

            //
            localStorage.setItem("iscametoElseScopeTAC", true);

            localStorage.setItem("UserInfoTAC", JSON.stringify(value));
            localStorage.setItem("AccessTokenTAC", keycloakInstance?.token);
            localStorage.setItem("idTokenTAC", keycloakInstance?.idToken);

            localStorage.setItem("isLoginTAC", true);
            let accessToken = keycloakInstance?.token;
            if (accessToken) {
              let headers = { Authorization: `Bearer ${accessToken}` };
              let SSOCheck = await axios.get(API.IsSSO, { headers });
              const isSSO = Boolean(SSOCheck.data);

              // Save to localStorage
              localStorage.setItem("isSSOConfigTAC", JSON.stringify(isSSO));
            }
            this.props.dispatch(Login(true));
            this.props.dispatch(Loader(false));
            this.setState({ isLogin: true });
            // this.setupIdleTimer();
          }
        } else {
          // this.setupIdleTimer();
          this.props.dispatch(Loader(false));
        }
      } catch (error) {
        console.log("Error fetching Keycloak configuration:", error);
        isOpen = false;
        this.setState({ isLogin: false });
        this.props.dispatch(Loader(false));
        // this.setupIdleTimer();
      }
    }
  };

  refreshAccessToken = async () => {
    try {
      const refreshedToken = await this.state.kc.updateToken(160);
      if (refreshedToken) {
        console.log("Token refreshed successfully");
        localStorage.setItem("AccessTokenTAC", this.state.kc?.token);
        localStorage.setItem("idTokenTAC", this.state.kc?.idToken);
        console.log(this.state.kc?.idTokenParsed, "Checking refresh");
        let roleTokenParsed = jwtDecode(this.state.kc?.token);
        console.log(roleTokenParsed);
        const roles =
          roleTokenParsed?.resource_access?.tenant_admin_center_app_id?.roles ||
          [];

        const userRoles =
          roles.length > 0
            ? roles.includes("Admin")
              ? "Admin"
              : roles[0]
            : this.state.kc?.idTokenParsed?.user_role || "";

        let value = {
          name: this.state.kc?.idTokenParsed?.name,
          expTime: this.state.kc?.idTokenParsed?.exp,
          userRole: userRoles,
          userId: this.state.kc?.idTokenParsed?.user_id || "",
        };
        // let value = {
        //   name: this.state.kc?.idTokenParsed?.name,
        //   expTime: this.state.kc?.idTokenParsed?.exp,
        //   userRole:
        //     roleTokenParsed.resource_access.tenant_admin_center_app_id
        //       .roles[0] ??
        //     (this.state.kc?.idTokenParsed?.user_role || ""),
        //   userId: this.state.kc?.idTokenParsed?.user_id || "",
        // };
        console.log(value);
        localStorage.setItem("UserInfoTAC", JSON.stringify(value));

        this.setState({ kc: this.state.kc });
        // this.props.dispatch(Loader(false));
      } else {
        // console.log("Token not refreshed, or not needed");
        // this.props.dispatch(Loader(false));
      }
    } catch (error) {
      console.log("Error refreshing token:", error);
      // this.props.dispatch(Loader(false));
    }
  };

  Interval = () => {
    setInterval(() => {
      if (this.state.kc) {
        // console.log('kc available', this.state.kc);
        let accessToken = localStorage.getItem("AccessTokenTAC");
        let tokenParsed = undefined;
        if (accessToken) {
          tokenParsed = this.state.kc?.idTokenParsed || jwtDecode(accessToken);
        } else {
          tokenParsed = this.state.kc?.idTokenParsed;
        }

        // console.log(tokenParsed);
        if (tokenParsed) {
          const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
          const tokenExpirationTime = tokenParsed.exp; // Expiration time of the token
          // console.log(
          //   tokenExpirationTime,
          //   currentTime,
          //   tokenExpirationTime - currentTime
          // );
          const expirationThreshold = 180;
          const isTokenAboutToExpire =
            tokenExpirationTime - currentTime <= expirationThreshold;

          if (isTokenAboutToExpire) {
            // console.log("Token is about to expire. Refreshing...");
            this.refreshAccessToken();
          }
        }
      }
    }, 1000);
  };

  handleLogin = async (userName) => {
    try {
      this.props.dispatch(Loader(true));

      const API_URL =
        authConfiguration.tenantApiUrl + "api/Login/Realm?UserName=" + userName;
      const response = await fetch(API_URL);
      const configData = await response.json();
      const realmName = configData[0];
      if (realmName) {
        localStorage.setItem("realmNameTAC", realmName);
        localStorage.setItem("userNameTAC", userName);

        this.fetchKeycloakConfig(userName);
      } else {
        this.props.dispatch(Loader(false));

        // window.location.href = "/usernotfound";
        window.location.href = "/admin/usernotfound";
      }
    } catch (error) {
      console.log(error);
      this.props.dispatch(Loader(false));
    }
  };

  // handleLogout = () => {
  //
  //     this.props.dispatch(Loader(true));
  //     console.log("Logging out due to inactivity.", this.state.kc);
  //     if (this.state.kc) {
  //         let redirectUrl=localStorage.getItem("redirectURL");
  //         console.log(redirectUrl);

  //         console.log( authConfiguration.logoutRedirectUri);
  //         this.state.kc.logout({ redirectUri: `${authConfiguration.logoutRedirectUri}logout?redirectUrl=${redirectUrl}`})
  //         localStorage.clear();
  //
  //         console.log('hello');

  //     }
  // }

  logoutFromGoogle = (url) => {
    // Create iframe
    const iframe = document.createElement("iframe");
    iframe.src = "https://accounts.google.com/Logout";
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    // Wait for iframe to load fully before redirecting
    iframe.onload = () => {
      console.log("Google logout iframe loaded");
      setTimeout(() => {
        window.location.href = url;
      }, 5000); // small delay after load
    };

    // Safety cleanup after a few seconds
    setTimeout(() => {
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe);
      }
    }, 5000);
  };

  handleLogout = async () => {
    const currentENV = process.env.REACT_APP_ENV;
    this.props.dispatch(Loader(true));
    console.log("Attempting to log out", this.state.kc);

    if (this.state.kc) {
      let userName = localStorage.getItem("userNameTAC");
      let values = await Actions.logoutRedirect(
        `${API.GET_LOGOUT}?email=${userName}`
      );
      localStorage.setItem("redirectURLTAC", values.data);
      let redirectUrl = values.data;
      console.log("Redirect URL:", redirectUrl);
      console.log("Logout redirect URI:", authConfiguration.logoutRedirectUri);

      try {
        // Clear local and session storage
        console.log("Clearing localStorage and sessionStorage");
        const idToken = localStorage.getItem("idTokenTAC");
        const realmName = localStorage.getItem("realmNameTAC");
        const keysToRemove = [
          "AccessTokenTAC",
          "UserInfoTAC",
          "isLoginTAC",
          "iscametoElseScopeTAC",
          "realmNameTAC",
          "redirectURLTAC",
          "userNameTAC",
          "idTokenTAC",
          "isSessionExpiredTAC",
          "isSSOConfigTAC",
        ];
        keysToRemove.forEach((key) => localStorage.removeItem(key));
        let kcvalue = this.state.kc;

        if (this.state.kc.token) {
          console.log("Clearing Keycloak token");
          this.state.kc.clearToken();
        }

        console.log("Calling Keycloak logout");
        
        let redirectTenant = "";

        let logoutUrl = "";
        let keycloakUrl = authConfiguration.keycloackUrl;
        const keycloakLogoutUrl = `${keycloakUrl}realms/${realmName}/protocol/openid-connect/logout`;
        let clientId = authConfiguration.clientId;
        let googleRedirect = "https://accounts.google.com/Logout";
        let redirectTenant1 = "";

        if (currentENV == "PROD") {
          let realm = this.getCurrentSubdomain() || "qantlersg";
          redirectTenant1 =
            redirectUrl !== ""
              ? `${`https://${realm}.${authConfiguration.logoutRedirectUri}`}?redirectUrl=${encodeURIComponent(
                  redirectUrl
                )}`
              : `https://${realm}.${authConfiguration.logoutRedirectUri}`;
        } else {
          redirectTenant1 =
            redirectUrl !== ""
              ? `${
                  authConfiguration.logoutRedirectUri
                }?redirectUrl=${encodeURIComponent(redirectUrl)}`
              : authConfiguration.logoutRedirectUri;
        }

        // const redirectTenant1 =
        //     redirectUrl !== ""
        //         ? `${`https://${realm}.${authConfiguration.logoutRedirectUri}`}?redirectUrl=${encodeURIComponent(redirectUrl)}`
        //         : `https://${realm}.${authConfiguration.logoutRedirectUri}`;
        // const redirectTenant1 =
        //   redirectUrl !== ""
        //     ? `${
        //         authConfiguration.logoutRedirectUri
        //       }?redirectUrl=${encodeURIComponent(redirectUrl)}`
        //     : authConfiguration.logoutRedirectUri;

        logoutUrl =
          `${keycloakLogoutUrl}` +
          `?id_token_hint=${idToken}` +
          `&client_id=${clientId}` +
          `&post_logout_redirect_uri=${encodeURIComponent(redirectTenant1)}`;
        // this.logoutFromGoogle(logoutUrl);
        // window.open("https://accounts.google.com/Logout", "_blank");
        const width = 400;
        const height = 300;

        // Handle multi-screen setups and get current browser position
        const dualScreenLeft = window.screenLeft ?? window.screenX;
        const dualScreenTop = window.screenTop ?? window.screenY;

        // Get browser viewport dimensions safely
        const browserWidth =
          window.innerWidth ??
          document.documentElement.clientWidth ??
          window.screen.width;

        const browserHeight =
          window.innerHeight ??
          document.documentElement.clientHeight ??
          window.screen.height;

        // Calculate center position relative to browser window
        const left = dualScreenLeft + (browserWidth - width) / 2;
        const top = dualScreenTop + (browserHeight - height) / 2;
        if (redirectUrl == googleRedirect) {
          const popup = window.open(
            "https://accounts.google.com/Logout",
            "_blank",
            `width=${width},height=${height},left=${left},top=${top}`
          );
          setTimeout(() => {
            popup.close();
          }, 1000);
        }
        window.location.href = logoutUrl;

        // if (redirectUrl !== "") {
        //     // redirectTenant = `https://${realm}.${authConfiguration.logoutRedirectUri}logout?redirectUrl=${redirectUrl}`
        //     redirectTenant = `${authConfiguration.logoutRedirectUri}logout?redirectUrl=${redirectUrl}`
        //     // redirectTenant = `${authConfiguration.logoutRedirectUri}logout?id_token_hint=${idToken}&redirectUrl=${redirectUrl}`
        // }
        // else {
        //     redirectTenant = `${authConfiguration.logoutRedirectUri}`
        //     // redirectTenant = `${authConfiguration.logoutRedirectUri}?id_token_hint=${idToken}`
        //     // redirectTenant = `https://${realm}.${authConfiguration.logoutRedirectUri}`
        // }
        // await kcvalue.logout({
        //     // redirectUri: `${authConfiguration.logoutRedirectUri}logout?redirectUrl=${redirectUrl}`
        //     redirectUri: redirectTenant
        // })

        console.log("Logout process completed");
      } catch (error) {
        console.error("Logout error:", error);
      }
    } else {
      console.error("Keycloak instance is not initialized");
    }
  };

  customLogin = (userName, password) => {
    if (this.state.kc) {
      this.state.kc.login({
        userName,
        password,
      });
    }
  };
  render() {
    return this.props.children({
      fetchKeycloakConfig: this.fetchKeycloakConfig,
      handleLogout: this.handleLogout,
      handleLogin: this.handleLogin,
      isLogin: this.state.isLogin,
      setIsLogin: (isLogin) => this.setState({ isLogin }),
      customLogin: this.customLogin,
    });
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    isLoading: state.loginReducer.isLoading,
    BG_LOADER: state.userReducer.BG_LOADER,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthFunctions);
